import { Component } from 'react';
import {connect} from 'react-redux';
import {actions, Form, Errors, Control} from 'forms/rrf';
import {Col, Container, FormGroup, Row} from 'react-bootstrap';
import { capitalize } from 'lodash';
import RequiredInput from '../../../../common/form/elements/required-input';
import BsCheckbox from '../../../../common/form/elements/bs-checkbox';
import BsRadio from '../../../../common/form/elements/bs-radio';
import BackLink from '../../../../common/back-link/index';
import PageTitle from '../../../../common/page-title/index';
import ArrowButton from '../../../../common/button-arrow';
import SectionTitle from '../../../../common/section-title/index';
import {getNavigationLinkBaseData, getNavigationLink, updateNavigationLink, saveNavigationLink}
  from '../../../../../actions/navigationlinks';
import GroupMultiSelect from '../../../../common/groups/group-multi-select';
import { getAllGroups } from '../../../../../actions/groups';

const generatePermissionsForEdit = (navigationLink, id) => {
  const {attributes: { permissions }} = navigationLink;
  if (permissions.length) {
    return (permissions.map((perm, index) => (
      <FormGroup className="permission-block" key={`perm-group-${index}`}>
        <b>
          {perm.name}
        </b>
        {
          perm.children.map((child, i) => {
            if (child.checked) {
              return (
                <Control.checkbox
                  key={`perm-${i}`}
                  defaultChecked
                  disabled={id === 1}
                  model={`deep.admin_navigationlink.permission_ids[${child.id}].checked`}
                  component={BsCheckbox}
                >
                  {child.name}
                </Control.checkbox>
              );
            }
            return (
              <Control.checkbox
                key={`perm-${i}`}
                component={BsCheckbox}
                disabled={id === 1}
                model={`deep.admin_navigationlink.permission_ids[${child.id}].checked`}
              >
                {child.name}
              </Control.checkbox>
            );
          })
        }
      </FormGroup>
    )));
  }
  return null;
};

const generatePermissions = (permissions) => {
  if (permissions.length) {
    return (permissions.map((perm, index) => (
      <FormGroup className="permission-block" key={`perm-group-${index}`}>
        <b>
          {perm.name}
        </b>
        {
          perm.children.map((child, i) => (
            <Control.checkbox
              key={`perm-${i}`}
              model={`deep.admin_navigationlink.permission_ids[${child.id}].checked`}
              component={BsCheckbox}
            >
              {child.name}
            </Control.checkbox>
          ))
        }
      </FormGroup>
    )));
  }
  return null;
};

class EditNavigationLink extends Component {
  onSubmit = (payLoad) => {
    if (this.state.id) {
      this.props.dispatch(actions.submitFields('deep.admin_navigationlink', updateNavigationLink(this.state.id, payLoad)));
    } else {
      this.props.dispatch(actions.submitFields('deep.admin_navigationlink', saveNavigationLink(payLoad)));
    }
  };

  constructor(props) {
    super(props);

    let title = 'ADD NAVIGATION LINK';
    if (+this.props.match.params.id) {
      title = 'EDIT NAVIGATION LINK';
    }

    this.state = {
      title,
      id: this.props.match.params.id,
    };
  }

  isEdit() {
    return this.state.id && parseInt(this.state.id);
  }

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getAllGroups()).then(() => {
      if (this.props.match.params.id === undefined) {
        dispatch(actions.reset('deep.admin_navigationlink'));
      } else {
        dispatch(getNavigationLink(this.props.match.params.id));
      }

      dispatch(getNavigationLinkBaseData());
    });
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.admin_navigationlink'));
    dispatch({ type: 'CLEAR_EDIT_NAVIGATIONLINK' });
  }

  render() {
    const { title } = this.state;
    const {
      permissions, loginStatuses, groups, formValid, navigationLink, navigationLinkLoading
    } = this.props;

    if (navigationLinkLoading) {
      return (
        <div className="container-fluid">
          <PageTitle>
            {title}
          </PageTitle>
          <Row>
            <Col lg={12}>
              Loading...
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <Container fluid className="navigationlinks">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/navigation/links"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              {title}
            </PageTitle>
          </Col>
        </Row>
        <Form
          model="deep.admin_navigationlink"
          onChange={() => {
            this.props.dispatch(actions.resetValidity('deep.admin_navigationlink'));
          }}
          onSubmit={payload => this.onSubmit(payload)}
          validators={{
            '': {
              url: vals => vals.url,
              name: vals => vals.name,
              login_status: vals => vals.login_status
            }
          }}
        >
          <Row>
            <Col md={12}>
              <RequiredInput
                label="Name"
                model=".name"
                placeholder="Name"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                label="URL"
                model=".url"
                placeholder="URL"
              />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <FormGroup>
                <div>Login status*</div>
                {loginStatuses.map(status => (
                  <Control.radio
                    model=".login_status"
                    key={status}
                    value={status}
                    inline
                    component={BsRadio}
                  >
                    {capitalize(status).replace('_', '-')}
                  </Control.radio>
                ))}

                <Errors
                  className="errors"
                  messages={{login_status: 'You must set login status.'}}
                  model="deep.admin_navigationlink"
                  show={{touched: true}}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <SectionTitle>
                Article permissions
              </SectionTitle>
              <FormGroup>
                <GroupMultiSelect
                  all={false}
                  model={'deep.admin_navigationlink.groups'}
                  required={false}
                  value={groups}
                />
              </FormGroup>
            </Col>
          </Row>
          {(!this.isEdit() && permissions) &&
          generatePermissions(permissions)
          }
          {(this.isEdit() && navigationLink) &&
          generatePermissionsForEdit(navigationLink, this.state.id)
          }
          <Row>
            <Col md={12}>
              <ArrowButton
                className="float-end"
                color="grey"
                disabled={!formValid}
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  navigationLink: state.navigationLinks.navigationLink,
  navigationLinkForm: state.deep.admin_navigationlink,
  loginStatuses: state.navigationLinks.loginStatuses,
  permissions: state.navigationLinks.permissions,
  formValid: state.deep.forms.admin_navigationlink.$form.valid,
  navigationLinkLoading: state.navigationLinks.fetching && !state.navigationLinks.fetched,
  fetched: state.navigationLinks.fetched,
  fetching: state.navigationLinks.fetching,
  groups: state.deep.admin_navigationlink.groups || [],
});

export default connect(mapStateToProps)(EditNavigationLink);
